ix-application {
    width: 100vw;
    height: 100vh;
}
.content-header {
    font-size: 18px;
    padding: 20px;
}

.app-logo {
  height: 1rem;
}